<template>
<div
  v-if='slide_result_loaded'
  class='consent-box'
>
  <label
    class='consent-box_terms copy-three'
    :class="{ 'consent-box_terms--disabled' : checkbox_disabled }"
  >
    <input
      v-model='is_consent'
      type='checkbox'
      name='consent'
      :disabled='checkbox_disabled'
    >

    <span>
      {{ $t('consent_checkbox_copy') }}

      <a
        :href='link_href'
        target='_blank'
        class='copy-three'
        @click='urlClick($event)'
      >
        {{ link_title }}
      </a>
    </span>
  </label>

  <div
    v-if='show_error'
    class='error copy-three'
  >
    {{ $t('consent_checkbox_error') }}
  </div>

  <button
    class='button-one-light'
    :class='cta_class'
    @click.prevent='buttonClick'
  >
    {{ cta }}
  </button>
</div>
</template>

<script>
export default {
  props: [
    'cta',
    'cta_action',
    'cta_class',
    'link_href',
    'link_title',
    'slide_result',
    'updateSlideResult'
  ],

  data() {
    return {
      is_consent: false,
      link_was_clicked: false,
      show_error: false,
      checkbox_disabled: null
    }
  },

  watch: {
    is_consent: function(value) {
      if (value) {
        this.show_error = false
      }
    },

    slide_result_loaded: {
      immediate: true,
      handler: function(value) {
        if (value) {
          this.loadUserConsentData()
        }
      }
    }
  },

  computed: {
    slide_result_loaded() {
      return Object.keys(this.slide_result).length
    }
  },

  methods: {
    urlClick(event) {
      this.link_was_clicked = true
    },

    buttonClick() {
      if (!this.is_consent) {
        this.show_error = true
      } else {
        if (this.is_consent) {
          this.updateUserConsent()
          this.checkbox_disabled = true
        }
        this.cta_action()
      }
    },

    updateUserConsent() {
      const results = Object.assign({}, this.slide_result.results)
      results.has_consented = this.is_consent
      this.updateSlideResult(this.slide_result.event, results)
    },

    loadUserConsentData() {
      if (this.slide_result.results && this.slide_result.results.hasOwnProperty('has_consented')) {
        this.is_consent = (this.slide_result.results.has_consented === true)

        if (this.checkbox_disabled === null) {
          this.checkbox_disabled = this.is_consent
        }
      }
    }
  }
}
</script>

<style lang='sass' scoped>
.consent-box
  max-width: 60%

  @media (max-width: 768px)
    max-width: 85%

  @media (max-width: 450px)
    max-width: 90%

  button
    display: block

  .consent-box_terms
    margin-top: 10px
    display: block
    position: relative
    text-align: left
    color: #fff

    a
      color: #fff

    @media (max-width: 450px) and (orientation: portrait)
      font-size: 14px

      a
        font-size: 14px

    input[type="checkbox"]
      appearance: none
      width: 20px
      height: 20px
      margin: -2px 5px 0 0
      padding: 0
      background: transparent
      border: 2px solid #fff
      display: inline-block
      vertical-align: middle
      cursor: pointer

      &:checked
        background: transparent

        & ~ span:before
          content: ""
          display: block
          position: absolute
          left: 5px
          top: 8px
          width: 9px
          height: 4px
          border: solid #fff
          border-width: 0 0 2px 2px
          transform: rotate(-45deg)
          cursor: pointer

    &.consent-box_terms--disabled
      opacity: 0.7

  .error
    color: #F67AA2 // pink
    text-align: left
    margin-left: 29px
    height: 0

    @media (max-width: 450px) and (orientation: portrait)
      font-size: 14px
      text-align: center
      margin-left: 0
</style>
